import { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import Home from "./pages/Home";
import Login from './pages/Login';
import Register from './pages/Register';
import PlayerDashboard from './pages/PlayerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import TopUp from './pages/TopUp';
import Success from './pages/Success';
import Leaderboard from './pages/Leaderboard';
import ConfirmRegistration from "./pages/ConfirmRegistration";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";
import RequireRole from "./pages/RequireRole";
import CookieBanner from "./components/CookieBanner";
import Noticeboard from "./pages/Noticeboard";
import Collections from "./pages/Collections";
import DeleteAccount from "./pages/DeleteAccount";
import { trackPageView } from "./utils/analytics";

import Navbar from './components/Navbar';

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const showNavbar = !['/', '/register','/terms'].includes(location.pathname);

  useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    let backButtonListener;
    let disposed = false;

    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else if (location.pathname !== '/') {
        navigate('/', { replace: true });
      } else {
        CapacitorApp.exitApp();
      }
    }).then((listener) => {
      if (disposed) {
        listener.remove();
      } else {
        backButtonListener = listener;
      }
    });

    return () => {
      disposed = true;
      backButtonListener?.remove();
    };
  }, [location.pathname, navigate]);

  return (
    <div>
      {showNavbar && <Navbar />}
      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/confirm" element={<ConfirmRegistration />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/delete-account" element={<DeleteAccount />} />

        {/* Player */}
        <Route path="/player" element={<PlayerDashboard />} />
        <Route path="/topup" element={<TopUp />} />
        <Route path="/success" element={<Success />} />
        <Route path="/noticeboard" element={<Noticeboard />} />
        <Route path="/collections" element={<Collections />} />

        {/* Admin-only */}
        <Route
          path="/admin"
          element={
            <RequireRole allow={['admin']} fallback="/superadmin">
              <AdminDashboard />
            </RequireRole>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <RequireRole allow={['admin']} fallback="/superadmin">
              <Leaderboard />
            </RequireRole>
          }
        />
      </Routes>
      <CookieBanner />
    </div>
  );
}
